import { initializeApp } from "firebase/app";
import {
  getMessaging,
  getToken,
  // onMessage,
  isSupported,
} from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBCpD9GbnuH3YAleZCoyW-GmXRKgJI0caE",
  authDomain: "ogwugo-courier-319221.firebaseapp.com",
  databaseURL: "https://ogwugo-courier-319221-default-rtdb.firebaseio.com",
  projectId: "ogwugo-courier-319221",
  storageBucket: "ogwugo-courier-319221.appspot.com",
  messagingSenderId: "611284402952",
  appId: "1:611284402952:web:95105d43fcbac8ab4322bd",
  measurementId: "G-Z36Y95YES7",
};

//Initialize Firebase
export const fireApp = initializeApp(firebaseConfig);
const firebaseUrl = process.env.REACT_APP_FIREBASE_URL;
const firebaseKey = process.env.REACT_APP_FIREBASE_API_KEY;
const vapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY;

export const initFirebaseMessaging = async () => {
  if (!(await isSupported())) return null;

  await navigator.serviceWorker.register("/firebase-messaging-sw.js");
  await navigator.serviceWorker.ready;

  const permission = await Notification.requestPermission();
  if (permission !== "granted") return null;

  const messaging = getMessaging(fireApp);

  // Get FCM token for this device
  const token = await getToken(messaging, {
    vapidKey: vapidKey,
  });

  if (token) {
    // generate a unique id for the browser
    const uuid = async () => {
      let uuid = await localStorage.getItem("UUID");
      if (!uuid) {
        uuid = Math.random().toString(36).slice(2) + Date.now();
        localStorage.setItem("UUID", uuid);
      }
      return uuid;
    };

    const createPayload = async () => {
      const deviceId = await uuid();
      const payLoad = {
        url: firebaseUrl,
        server_key: firebaseKey,
        device_token: token,
        device_id: deviceId,
        device_type: "web",
        notification_type: "direct",
        notification_agent: "firebase",
      };
      return payLoad;
    };

    const payLoad = await createPayload();

    localStorage.setItem("firebaseDetails", JSON.stringify({ ...payLoad }));
  }

  return messaging;
};
